import { render, staticRenderFns } from "./CashRewardList.vue?vue&type=template&id=08d2bf40&scoped=true&"
import script from "./CashRewardList.vue?vue&type=script&lang=js&"
export * from "./CashRewardList.vue?vue&type=script&lang=js&"
import style0 from "./CashRewardList.vue?vue&type=style&index=0&id=08d2bf40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2bf40",
  null
  
)

export default component.exports